"use client";

import { FORM_TYPES } from "@/utils";
import React, { useEffect, useState } from "react";
import { ForgotPasswordForm, LoginForm, RegisterForm } from "./AuthForms";

interface MobileAuthProps {
  onSuccess?: () => void;
  onClose?: () => void;
  initialMode?: typeof FORM_TYPES[keyof typeof FORM_TYPES];
  onModeChange?: (mode: typeof FORM_TYPES[keyof typeof FORM_TYPES]) => void;
  showTabs?: boolean;
}

const MobileAuth: React.FC<MobileAuthProps> = ({ onSuccess, onClose, initialMode = FORM_TYPES.LOGIN, onModeChange, showTabs = true }) => {
  const [currentMode, setCurrentMode] = useState<typeof FORM_TYPES[keyof typeof FORM_TYPES]>(initialMode);

  // Update internal state when prop changes
  useEffect(() => {
    setCurrentMode(initialMode);
  }, [initialMode]);

  const handleModeChange = (mode: typeof FORM_TYPES[keyof typeof FORM_TYPES]) => {
    setCurrentMode(mode);
    onModeChange?.(mode);
  };

  const handleSuccess = () => {
    onSuccess?.();
    onClose?.();
  };

  const renderForm = () => {
    switch (currentMode) {
      case FORM_TYPES.LOGIN:
        return <LoginForm onSuccess={handleSuccess} onModeChange={handleModeChange} />;
      case FORM_TYPES.REGISTER:
        return <RegisterForm onSuccess={handleSuccess} onModeChange={handleModeChange} />;
      case FORM_TYPES.FORGOT_PASSWORD:
        return <ForgotPasswordForm onModeChange={handleModeChange} />;
      default:
        return <LoginForm onSuccess={handleSuccess} onModeChange={handleModeChange} />;
    }
  };

  return (
    <div className={`w-full ${showTabs ? 'h-full flex flex-col' : 'max-w-md mx-auto'}`}>
      {showTabs && (
        <div className="flex border-b border-light-grey mb-6 font-raleway text-md">
          <button 
            className={`px-2 pb-3 text-center ${
              currentMode === FORM_TYPES.LOGIN ? "border-b-2 border-black" : "text-gray-400"
            }`}
            onClick={() => handleModeChange(FORM_TYPES.LOGIN)}
          >
            Login
          </button>
          <button 
            className={`px-2 pb-3 text-center ${
              currentMode === FORM_TYPES.REGISTER ? "border-b-2 border-black" : "text-gray-400"
            }`}
            onClick={() => handleModeChange(FORM_TYPES.REGISTER)}
          >
            Register
          </button>
        </div>
      )}
      
      {/* Form Content */}
      <div className={showTabs ? "flex-1 overflow-y-auto" : ""}>
        {renderForm()}
      </div>
    </div>
  );
};

export default MobileAuth;
